module.exports = __webpack_public_path__ + "assets/images/announcement-spring-cleaning.png";